import { Grid, TextField, Typography } from '@material-ui/core'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { GetCustomerAccountBalanceQuery } from '../../../graphql/camel'
import { FormValues } from '../../../lib/cart/types'
import { formatAsCurrencyOrZero } from '../../../utils/priceTools'

export interface PurchaseOrderFormProps {
  accountBalance: GetCustomerAccountBalanceQuery['getCustomerAccountBalance']
  availableCredit: number
  daysOverdue: number
  poCreditLimitError: boolean
  poDaysOverdueError: boolean
  paymentMethod: string
}

const PurchaseOrderForm: React.FC<PurchaseOrderFormProps> = ({
  paymentMethod,
  accountBalance,
  availableCredit,
  poCreditLimitError,
  poDaysOverdueError,
  daysOverdue,
}) => {
  const { register } = useFormContext<FormValues.PurchaseOrder>()
  const isOnCreditHold = !!accountBalance?.onCreditHold

  if (paymentMethod !== 'purchaseorder' || !accountBalance) {
    return null
  }

  return (
    <>
      {poCreditLimitError && poDaysOverdueError && (
        <Grid item xs={12}>
          <Typography variant="body2" color="error" gutterBottom>
            Our records indicate that your account is either overdue or you have exceeded your
            monthly credit limit. To proceed with this purchase please choose the credit card
            payment option. Please contact DFH Accounts Receivable at ar@designsforhealth.com to pay
            your outstanding account balance.
          </Typography>
        </Grid>
      )}
      {poCreditLimitError && !poDaysOverdueError && (
        <Grid item xs={12}>
          <Typography variant="body2" color="error" gutterBottom>
            Not enough balance, please use credit card to complete purchase.
          </Typography>
        </Grid>
      )}
      {isOnCreditHold && (
        <Grid item xs={12}>
          <Typography variant="body2" color="error" gutterBottom>
            Your account currently has a credit hold placed on it. Please reach out to our Customer
            Experience team at (860) 623-6314 for additional information.
          </Typography>
        </Grid>
      )}
      {!poCreditLimitError && poDaysOverdueError && (
        <Grid item xs={12}>
          <Typography variant="body2" color="error" gutterBottom>
            Our records show that your account is {daysOverdue} days overdue. To proceed with this
            purchase please choose the credit card payment option. Please contact DFH Accounts
            Receivable at ar@designsforhealth.com to pay your outstanding account balance.
          </Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography variant="body2">Terms: {accountBalance.terms}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" gutterBottom>
          Available Credit:{' '}
          {isOnCreditHold ? 'On Hold' : formatAsCurrencyOrZero({ amount: availableCredit })}
        </Typography>
      </Grid>
      <TextField
        InputProps={{ disableUnderline: true }}
        fullWidth
        variant="filled"
        inputRef={register({ maxLength: 25, pattern: /^[0-9a-zA-Z]+$/ })}
        name="purchaseOrderNumber"
        label="Enter purchase order (optional)"
        disabled={isOnCreditHold || poCreditLimitError || poDaysOverdueError}
      />
    </>
  )
}

export default PurchaseOrderForm
